module.exports = __webpack_public_path__ + "static/media/20201216_201534_259_IMG_3194.01140417.jpg";